/**
 * "Comprobar en la AEAT" — opción A aceptada el 2026-09-17.
 *
 * La aplicación valida el NIF SÓLO por formato (`VALID_FORMAT`, OD-0015 D-03,
 * URS §10). La identidad la comprueba el USUARIO, que es el responsable de los
 * datos de sus clientes, en la Sede de la AEAT con su propia identificación
 * (Cl@ve, certificado o DNIe). Aquí sólo se le lleva a la página oficial:
 *
 *   030  "Comprobación de un NIF de terceros a efectos censales": personas y
 *        entidades; compara NIF y nombre (identificado / similar / no).
 *   036  "Consulta por NIF de entidades jurídicas": si la entidad está censada.
 *
 * Páginas comprobadas el 2026-09-17 (título y contenido). Nada viaja a la AEAT
 * desde aquí: ni el NIF ni el nombre se añaden al enlace, y la aplicación NO
 * marca nada como verificado (IDENTITY_VERIFIED queda para la opción B,
 * TDS-AEAT).
 */
import { t } from "../i18n/es";

export const SEDE_AEAT = {
  modelo030:
    "https://sede.agenciatributaria.gob.es/Sede/ayuda/consultas-informaticas/presentacion-declaraciones-ayuda-tecnica/modelo-030/comprobacion-nif-terceros-efectos-censales.html",
  modelo036:
    "https://sede.agenciatributaria.gob.es/Sede/ayuda/consultas-informaticas/presentacion-declaraciones-ayuda-tecnica/modelo-036/comprobacion-estar-censado-consulta-nif-juridicas.html",
} as const;

/** Sólo para identificaciones españolas: la Sede no comprueba NIF-IVA ni extranjeros. */
export function EnlacesComprobarAeat({ tipo }: { tipo: string | null }) {
  if (tipo !== "NIF_ES_PERSON" && tipo !== "NIE_ES" && tipo !== "NIF_ES_ENTITY") return null;
  return (
    <div className="comprobar-aeat">
      <p className="ayuda-neutra">{t.aeat.explicacion}</p>
      <div className="acciones-en-linea">
        <a className="boton boton-secundario enlace-boton" href={SEDE_AEAT.modelo030} target="_blank" rel="noopener noreferrer">
          {t.aeat.comprobarNif}
        </a>
        {tipo === "NIF_ES_ENTITY" ? (
          <a className="boton boton-secundario enlace-boton" href={SEDE_AEAT.modelo036} target="_blank" rel="noopener noreferrer">
            {t.aeat.comprobarAlta}
          </a>
        ) : null}
      </div>
    </div>
  );
}
